import { render } from "./header_menu.vue?vue&type=template&id=82d022f8&scoped=true"
import script from "./header_menu.vue?vue&type=script&lang=js"
export * from "./header_menu.vue?vue&type=script&lang=js"

import "./header_menu.vue?vue&type=style&index=0&id=82d022f8&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82d022f8"]])

export default __exports__